import {z} from 'zod';
import {ApiDefinition} from '../definitions';
import {ObjectIdSchema} from '../../zod';

export const MaxApiKeys = 5;

export const GetApiKeys = {
  path: 'api/keys',
  method: 'get',
  options: {access: 'paid'},
  requestDataSchema: z.object({}),
  responseDataSchema: z.array(
    z.object({
      _id: ObjectIdSchema,
      key: z.string(),
      generated: z.date(),
    })
  ),
} satisfies ApiDefinition;

export const CreateApiKey = {
  path: 'api/keys/create',
  method: 'post',
  options: {access: 'paid'},
  requestDataSchema: z.object({}),
  responseDataSchema: z.object({
    _id: ObjectIdSchema,
    key: z.string(),
    generated: z.date(),
  }),
} satisfies ApiDefinition;

export const DeleteApiKey = {
  path: 'api/keys/delete',
  method: 'post',
  options: {access: 'paid'},
  requestDataSchema: z.object({
    keyId: ObjectIdSchema,
  }),
  responseDataSchema: z.void(),
} satisfies ApiDefinition;
